import { render, staticRenderFns } from "./TweeningNumber.vue?vue&type=template&id=2fbe2c8d&"
import script from "./TweeningNumber.vue?vue&type=script&lang=ts&"
export * from "./TweeningNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports